import { FormElement, Properties } from '.';

/* istanbul ignore file */
export class Schema {
    elements?: FormElement[];
    properties?: Properties;
    required?: string[];
    type?: string;
}
